document.addEventListener('DOMContentLoaded', () => {
	document.querySelectorAll('a[href="#chat"]').forEach((element) => {
		// Toggle Live Chat window.
		element.addEventListener('click', (event) => {
			event.preventDefault();

			const chatButton = document.querySelector('#silc-btn');

			if (chatButton) {
				// Trigger a click on the Social Intents button.
				chatButton.click();
			}
		});
	});
});
